import { DeliveryType } from '@/consts/washRequest';

const SAME_DAY_CUTOFF_HOUR = 11;

export function useDeliveryType(args) {
  const {
    now,
    isOnetimeAreaBravo,
  } = args;

  // 単発プランBエリアは当日配達不可
  const sameDayDisabledReason = isOnetimeAreaBravo ? 'area_b' : null;

  const isSameDayDisabled = sameDayDisabledReason !== null;
  const baseTypes = [DeliveryType.NEXT_DAY, DeliveryType.TWO_DAYS_LATER];
  const availableTypes = isSameDayDisabled ? baseTypes : [...baseTypes, DeliveryType.SAME_DAY];
  const defaultType = resolveDefaultType({ now, isSameDayDisabled });

  return { availableTypes, defaultType, isSameDayDisabled, sameDayDisabledReason };
}

export function isSameDayAfterCutoff(pickupDate, now) {
  return isSameDay(now, pickupDate) && now.getHours() >= SAME_DAY_CUTOFF_HOUR;
}

export function buildInitialDeliveryTypeContext() {
  return {
    availableTypes: [
      DeliveryType.SAME_DAY,
      DeliveryType.NEXT_DAY,
      DeliveryType.TWO_DAYS_LATER,
    ],
    defaultType: DeliveryType.NEXT_DAY,
    isSameDayDisabled: false,
    sameDayDisabledReason: null,
  };
}

function resolveDefaultType(ctx) {
  if (ctx.isSameDayDisabled) return DeliveryType.NEXT_DAY;
  if (ctx.now.getHours() >= SAME_DAY_CUTOFF_HOUR) return DeliveryType.NEXT_DAY;
  return DeliveryType.SAME_DAY;
}

function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}
